import { Injectable, inject } from '@angular/core';
import { ConsumerLoginConfig } from '../models';
import { LocalStorageService } from './local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class PrivacyPolicyService {
    private readonly localStorage = inject(LocalStorageService);

    inputs: ConsumerLoginConfig | undefined;

    getPrivacyTermsLink(): string | boolean {
        if (this.inputs?.privacyURL) {
            return this.inputs.privacyURL;
        }
        return false;
    }

    isPrivacyTermsDisplayed(): boolean {
        return !this.localStorage.privacyPolicyAccepted && this.getPrivacyTermsLink() !== false;
    }
}
